import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
Vue.use(Router)


export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }// return desired position
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },    
    {
      path: '/AboutUS',
      name: 'AboutUS',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/mobileAbout.vue')
    },   
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue')
    }, 
    {
      path: '/mobileNews',
      name: 'mobileNews',
      component: () => import('./views/mobileNews.vue')
    },    
    {
      path: '/advocate',
      name: 'advocate',
      component: () => import('./views/advocate.vue')
    },
    {
      path: '/mobileAdvocate',
      name: 'mobileAdvocate',
      component: () => import('./views/mobileAdvocate.vue')
    },
    {
      path: '/advocate/newPlus',
      name: 'newPlus',
      component: () => import('./views/newPlus.vue')
    },
    {
      path: '/advocate/mobilenewPlus',
      name: 'mobilenewPlus',
      component: () => import('./views/mobilenewPlus.vue')
    },
    {
      path: '/advocate/goldenPrime',
      name: 'goldenPrime',
      component: () => import('./views/goldenPrime.vue')
    },
    {
      path: '/advocate/goldenPrime2',
      name: 'goldenPrime2',
      component: () => import('./views/goldenPrime2.vue')
    },
    {
      path: '/advocate/mobilegoldenPrime',
      name: 'mobilegoldenPrime',
      component: () => import('./views/mobilegoldenPrime.vue')
    },
    {
      path: '/advocate/mobilegoldenPrime2',
      name: 'mobilegoldenPrime2',
      component: () => import('./views/mobilegoldenPrime2.vue')
    },
    {
      path: '/advocate/goldenFront',
      name: 'goldenFront',
      component: () => import('./views/goldenFront.vue')
    },
    {
      path: '/advocate/mobilegoldenFront',
      name: 'mobilegoldenFront',
      component: () => import('./views/mobilegoldenFront.vue')
    },
    {
      path: '/advocate/goldenLV',
      name: 'goldenLV',
      component: () => import('./views/goldenLV.vue')
    },
    {
      path: '/advocate/mobilegoldenLV',
      name: 'mobilegoldenLV',
      component: () => import('./views/mobilegoldenLV.vue')
    },
    {
      path: '/advocate/goldenDouble',
      name: 'goldenDouble',
      component: () => import('./views/goldenDouble.vue')
    },
    {
      path: '/advocate/goldenDragon',
      name: 'goldenDragon',
      component: () => import('./views/goldenDragon.vue')
    },
    {
      path: '/advocate/goldenBerkley',
      name: 'goldenBerkley',
      component: () => import('./views/goldenBerkley.vue')
    },
    {
      path: '/advocate/goldenBig',
      name: 'goldenBig',
      component: () => import('./views/goldenBig.vue')
    },
    {
      path: '/advocate/goldenWorld',
      name: 'goldenWorld',
      component: () => import('./views/goldenWorld.vue')
    },
    {
      path: '/advocate/mobilegoldenDouble',
      name: 'mobilegoldenDouble',
      component: () => import('./views/mobilegoldenDouble.vue')
    },
    {
      path: '/advocate/mobilegoldenDragon',
      name: 'mobilegoldenDragon',
      component: () => import('./views/mobilegoldenDragon.vue')
    },
    {
      path: '/advocate/mobilegoldenWorld',
      name: 'mobilegoldenWorld',
      component: () => import('./views/mobilegoldenWorld.vue')
    },
    {
      path: '/advocate/mobilegoldenBerkley',
      name: 'mobilegoldenBerkley',
      component: () => import('./views/mobilegoldenBerkley.vue')
    },
    {
      path: '/advocate/mobilegoldenBig',
      name: 'mobilegoldenBig',
      component: () => import('./views/mobilegoldenBig.vue')
    },
    {
      path: '/advocate/goldenIntegrity',
      name: 'goldenIntegrity',
      component: () => import('./views/goldenIntegrity.vue')
    },
    {
      path: '/advocate/mobilegoldenIntegrity',
      name: 'mobilegoldenIntegrity',
      component: () => import('./views/mobilegoldenIntegrity.vue')
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('./views/contactUs.vue')
    },
    {
      path: '/mobileContact',
      name: 'mobileContact',
      component: () => import('./views/mobileContact.vue')
    },
  ]
})
